import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { claimWayMessages } from './claimWayMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the claim way; each part uses its own slice of it */
import styles from './ClaimWay.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** "Same song" for a sure match, "Check" for a possible one. */
const MatchTagComponent: React.FC<{ isSure: boolean }> = ({ isSure }) => {
  const intl = useIntl();
  return (
    <span className={clsx(styles.tag, isSure ? styles.tagSure : styles.tagPossible)}>
      {intl.formatMessage(isSure ? claimWayMessages.sameSong : claimWayMessages.check)}
    </span>
  );
};

export const MatchTag = TypedMemo(MatchTagComponent);
